import React from "react"
import { useCrm } from "../../../contexts/crmContext"
import ProgressSetup from "./ProgressSetup";
import SetupGuide from "./SetupGuide";
import { BsFunnel } from "react-icons/bs";

const initialData = {
    funnel: {
        name: "Comercial",
    },
    stages: [
        { name: "Novo Lead", time_to_cool: 1 },
        { name: "Dia 02", time_to_cool: 1 },
        { name: "Dia 03", time_to_cool: 1 },
        { name: "Dia 04", time_to_cool: 1 },
        { name: "Dia 05", time_to_cool: 1 },
        { name: "Em negociação", time_to_cool: 3 },
        { name: "Proposta", time_to_cool: 2 },
        { name: "Remarketing", time_to_cool: 10 },
    ]
}

const AddFirstFunnel = ({ step = 0, totalSteps = 4, funnel_id, nextStep = () => { } }) => {
    const { openModalFunnel } = useCrm()

    const title = "Monte seu primeiro funil"
    const description = "O funil mostra em que momento cada lead está e ajuda a equipe a saber qual é a próxima ação."
    const btnText = funnel_id ? "Revisar funil" : "Configurar funil"

    return (
        <ProgressSetup
            step={step}
            totalSteps={totalSteps}
            title={title}
            description={description}
            btnText={btnText}
            onClick={() => openModalFunnel(!funnel_id, funnel_id, initialData, nextStep)}
        >
            <SetupGuide
                icon={<BsFunnel />}
                title="Configure as etapas do processo comercial"
                items={[
                    { title: "Dê um nome ao funil", description: "Use um nome fácil de reconhecer, como Comercial, Matrículas ou Pós-venda." },
                    { title: "Revise e ordene as etapas", description: "Arraste pela alça lateral para colocar as etapas na ordem em que o atendimento acontece." },
                    { title: "Defina o tempo de atenção", description: "Na engrenagem, informe em quantos dias um lead deve ser considerado sem atividade." },
                ]}
                note="Já deixamos uma estrutura comercial sugerida. Você pode editar, excluir ou adicionar etapas."
            />
        </ProgressSetup>
    )
}

export default AddFirstFunnel
